<script setup lang="ts">
import {determineUspBoxWidth} from '@/ts/utilities.ts';
import {defineAsyncComponent, onMounted} from "vue";
const USP = defineAsyncComponent(() => import("@/components/ui/USP.vue"))

interface Props {
	usps: {
		type: Object,
		default: () => {}
	}
}

const props = defineProps<Props>();

</script>

<template>
	<div class="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
		<USP v-for="(box, index) in usps"  :usp="box" context="content" layout="card" :key="index"></USP>
	</div>
</template>
